module.exports = __webpack_public_path__ + "overview-a5b6df21/free-cover-3afb766bab04848423d6efdb4f226321.svg";